import React from 'react';

import Helmet from 'common/helmets/Helmet';

const Title = 'GiveButter Case Study | Canny';
const Description =
  'Read about how GiveButter crushed their NPS and predicted the future with Canny';
const Image = 'https://canny.io/images/167803ef4cd8fc9272d25c5f55eb1694.jpg';

const GiveButterLandingHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/case-studies/givebutter' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
};

export default GiveButterLandingHelmet;
